module.exports = __webpack_public_path__ + "img/title+@2x.70d9f695.png";